import React from "react";
import PropTypes from "prop-types";

import { ConditionName, ConditionOperator, ConditionValue } from "./components";

export function ConditionsGroupDetails({ conditions }) {
  return conditions.map((condition) => {
    return (
      <div
        key={condition.id}
        style={{
          display: "flex",
          flexFlow: "row",
          marginLeft: condition?.operator ? "0.9em" : "",
        }}
      >
        <ConditionOperator operator={condition?.operator} />
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "baseline",
            marginLeft: "0.5em",
          }}
        >
          <ConditionName
            type={condition.type}
            name={condition.name}
            datePart={condition?.datePart}
            workflowPart={condition?.workflowPart}
            formFieldName={condition?.formField?.name}
          />
          <ConditionValue
            type={condition.type}
            operand={condition.operand}
            formFieldType={condition?.formField?.type}
            value={condition?.value}
            datePart={condition?.datePart}
            streams={condition?.streams}
            tags={condition?.tags}
          />
        </div>
      </div>
    );
  });
}

ConditionsGroupDetails.propTypes = {
  conditions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      operand: PropTypes.string.isRequired,
      operator: PropTypes.string,
      formField: PropTypes.shape({
        type: PropTypes.object,
        name: PropTypes.string,
      }),
      value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
      streams: PropTypes.array,
      tags: PropTypes.array,
    })
  ),
};

ConditionsGroupDetails.defaultProps = {
  conditions: [],
};

export default ConditionsGroupDetails;
